import { IInstrumentosEjecucion } from "../../../interfaces/InstrumentosEjecucion";
import { IInformacionGeneral } from "../../../interfaces/InformacionGeneral";
import { Sections } from "../../../util/types";
import IPresupuestoHistorico from "../../../interfaces/PresupuestoHistorico";
import Iniciativas from "./Iniciativas";
import Logros from "./Logros";
import PresupuestoAsignadoEjecutado from "./PresupuestoAsignadoEjecutado";
import Contrapartes from "./Contrapartes";
import Territorios from "./Territorios";

const SubSectionsContainer:React.FC<{ 
    code?: string,
    section:Sections
}>  = ({code, section}) => {
    
    switch (section) {
        case "initiatives":
            return <Iniciativas code={code}/>
        case "logros":
            return <Logros code={code}/>
        case "executed":
            return <PresupuestoAsignadoEjecutado code={code} mode="ejecutado" />
        case "allocated":
            return <PresupuestoAsignadoEjecutado code={code} mode="asignado" />
        case "contrapartes":
            return <Contrapartes code={code} />
        case "territorios":
            return <Territorios code={code} />
        default:
            return null
    }
}

export default SubSectionsContainer